import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import config from "../config";



export default function getStyleRondMaille1Variable(feature, bord = false, remplirlisteexport = true) {
    var donneesexport = [];
    var opacite = [0.5, 0.67, 0.84];
    var c1 = 0;
    var donneeexport = { "type": "Feature", "properties": { "afficher": true }, "geometry": { "type": "Point", "coordinates": feature.getGeometry().getCenter() } }
    //console.log(feature)
    donneeexport.properties["taillecercle"] = feature.getGeometry().getRadius();
    if (typeof variable !== "undefined") {
        donneeexport.properties["var1"] = parseFloat(feature.getProperties().nbre4);
    }

    if (typeof feature.getProperties().nbre1 != "undefined" && feature.getProperties().nbre1 != null) {
        var quartiles = feature.getProperties().quartiles1;
        var var1 = parseFloat(feature.getProperties().nbre1);
        var checkTheme1 = feature.getProperties().checkTheme1;
        
        var siafficher = false;
        if (feature.getProperties().operation1.signe === "inf") {
            siafficher = parseFloat(feature.getProperties().nbre1) <= parseFloat(feature.getProperties().operation1.valeur);
        } else {
            siafficher = parseFloat(feature.getProperties().nbre1) >= parseFloat(feature.getProperties().operation1.valeur);
        }
        if (siafficher && checkTheme1) {
            c1 = var1 <= quartiles[0] ? opacite[0] : var1 <= quartiles[1] ? opacite[1] : var1 <= quartiles[2] ? opacite[2] : 1;
            donneeexport.properties.couleur = "#" + Math.round(c1 * 255 >= 255 ? 255 : c1 * 255).toString(16) + config.couleur_theme1[0].toString(16) + config.couleur_theme1[1].toString(16) + config.couleur_theme1[2].toString(16);
            donneeexport.properties["var1"] = feature.getProperties().nbre1;
            if (remplirlisteexport)
                donneesexport.push(donneeexport);
            return new Style({
                stroke: new Stroke({
                    color: 'rgba(' + config.couleur_theme1[0] + ',' + config.couleur_theme1[1] + ',' + config.couleur_theme1[2] + ',' + c1 + ')',
                    width: 0
                }),
                fill: new Fill({
                    color: 'rgba(' + config.couleur_theme1[0] + ',' + config.couleur_theme1[1] + ',' + config.couleur_theme1[2] + ',' + c1 + ')'
                })
            });
        }
    } else if (typeof feature.getProperties().nbre2 != "undefined" && feature.getProperties().nbre2 !== null) {
        quartiles = feature.getProperties().quartiles2;
        var var2 = parseFloat(feature.getProperties().nbre2);
        var checkTheme2 = feature.getProperties().checkTheme2;

        siafficher = false;
        if (feature.getProperties().operation2.signe === "inf") {
            siafficher = parseFloat(feature.getProperties().nbre2) <= feature.getProperties().operation2.valeur;
        } else {
            siafficher = parseFloat(feature.getProperties().nbre2) >= feature.getProperties().operation2.valeur;
        }
        if (siafficher && checkTheme2) {
            c1 = var2 <= quartiles[0] ? opacite[0] : var2 <= quartiles[1] ? opacite[1] : var2 <= quartiles[2] ? opacite[2] : 1;
            donneeexport.properties.couleur = "#" + Math.round(c1 * 255 >= 255 ? 255 : c1 * 255).toString(16) + config.couleur_theme2[0].toString(16) + config.couleur_theme2[1].toString(16) + config.couleur_theme2[2].toString(16);
            donneeexport.properties["var2"] = feature.getProperties().nbre2;
            if (remplirlisteexport)
                donneesexport.push(donneeexport);
            return new Style({
                stroke: new Stroke({
                    color: 'rgba(' + config.couleur_theme2[0] + ',' + config.couleur_theme2[1] + ',' + config.couleur_theme2[2] + ',' + c1 + ')',
                    width: 0
                }),
                fill: new Fill({
                    color: 'rgba(' + config.couleur_theme2[0] + ',' + config.couleur_theme2[1] + ',' + config.couleur_theme2[2] + ',' + c1 + ')'
                })
            });
        }
    } else if (typeof feature.getProperties().nbre3 != "undefined" && feature.getProperties().nbre3 !== null) {
        quartiles = feature.getProperties().quartiles2;
        var checkTheme3 = feature.getProperties().checkTheme3;

        var var3 = parseFloat(feature.getProperties().nbre3);
        siafficher = false;
        if (feature.getProperties().operation3.signe === "inf") {
            siafficher = parseFloat(feature.getProperties().nbre3) <= feature.getProperties().operation3.valeur;
        } else {
            siafficher = parseFloat(feature.getProperties().nbre3) >= feature.getProperties().operation3.valeur;
        }
        if (siafficher && checkTheme3) {
            c1 = var3 <= quartiles[0] ? opacite[0] : var3 <= quartiles[1] ? opacite[1] : var3 <= quartiles[2] ? opacite[2] : 1;
            donneeexport.properties.couleur = "#" + Math.round(c1 * 255 >= 255 ? 255 : c1 * 255).toString(16) + config.couleur_theme3[0].toString(16) + config.couleur_theme3[1].toString(16) + config.couleur_theme3[2].toString(16);
            donneeexport.properties["var3"] = feature.getProperties().nbre3;
            if (remplirlisteexport)
                donneesexport.push(donneeexport);
            return new Style({
                stroke: new Stroke({
                    color: 'rgba(' + config.couleur_theme3[0] + ',' + config.couleur_theme3[1] + ',' + config.couleur_theme3[2] + ',' + c1 + ')',
                    width: 0
                }),
                fill: new Fill({
                    color: 'rgba(' + config.couleur_theme3[0] + ',' + config.couleur_theme3[1] + ',' + config.couleur_theme3[2] + ',' + c1 + ')'
                })
            });
        }
    }

}